import type { ReactNode } from "react";
import { site } from "@/config/site";
import { track } from "@/lib/analytics";

type Props = {
  className?: string;
  children?: ReactNode;
};

export function LinkedInMessageLink({
  className,
  children = "Message on LinkedIn",
}: Props) {
  return (
    <a
      className={className}
      href={site.profiles.linkedin}
      target="_blank"
      rel="noopener noreferrer"
      onClick={() => track("linkedin-message-clicked")}
    >
      {children}
    </a>
  );
}
